import React from 'react';
import { Navigate } from 'react-router';
import Base from '../Base';
import { Header } from '../Header';
import { Footer } from '../Footer';
//npm i react-multi-date-picker
//https://www.npmjs.com/package/react-multi-date-picker
import { Calendar } from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
//import persian_fa from "react-date-object/locales/persian_fa";
import gregorian from "react-date-object/calendars/gregorian";
import gregorian_en from "react-date-object/locales/gregorian_en";

// ساخت لوکال فارسی سفارشی
const customPersian = {
    name: "persian_fa_custom",
    months: [
        ["فروردین"], ["اردیبهشت"], ["خرداد"], ["تیر"], ["مرداد"], ["شهریور"],
        ["مهر"], ["آبان"], ["آذر"], ["دی"], ["بهمن"], ["اسفند"]
    ],
    weekDays: [
        ["شنبه", "شنبه"],
        ["یکشنبه", "یکشنبه"],
        ["دوشنبه", "دوشنبه"],
        ["سه‌شنبه", "سه‌شنبه"],
        ["چهارشنبه", "چهارشنبه"],
        ["پنجشنبه", "پنجشنبه"],
        ["جمعه", "جمعه"]
    ],
    //digits: ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"],
    digits: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"],
    meridiems: [
        ["قبل از ظهر", "ق.ظ"],
        ["بعد از ظهر", "ب.ظ"]
    ]
};

export default class ProductionCalendar extends Base {
    constructor(props) {
        super(props);

        this.state = {
            caller: props.Caller,
            controllerName: 'productionline',
            popupComponent: null,
            data: null,
            calendarData: null,
            loading: true,
            systemModuleId: 35,
            moduleAccessStatus: 1,
            menuId: 104,
            calendarType: "persian",
            currentYear: 0,
            currentMonth: 0
        };
        this.keyDownFunction = this.keyDownFunction.bind(this);
    }
    componentWillUnmount() {
        this.removeKeyDown();
    }

    getLinesForDate(dateString) {
        var dayData = this.state.calendarData.find(d => d.date === dateString);
        if (dayData) {
            dayData.lines.forEach(line => {
                var _line = null;
                this.state.data.lines.forEach(_ => {
                    if (_.id === line.lineId) _line = _;
                });

                if (!this.isNull(_line)) {
                    line.lineName = _line.name ;
                    line.color = _line.color;
                }
            })
            return dayData.lines;
        }
        return []
    }
    //toggleCalendarType = () => {
    //    this.setState(prevState => ({
    //        calendarType: prevState.calendarType === "persian" ? "gregorian" : "persian"
    //    }));
    //};
    componentDidMount() {
        this.httpPost("api/v1/common/check/module/access", {
            systemModuleId: this.state.systemModuleId
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                this.state.moduleAccessStatus = data.status;

                this.refreshData();
            });
    }
    refreshData() {
        this.httpPost("api/v1/productionline/calendar/", {
            year: this.state.currentYear,
            month: this.state.currentMonth
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.state.calendarData = data.records;
                    this.setState({
                        data: data,
                        loading: false
                    })
                }
                else {
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    handleMonthChange = (dateObj) => {
        const year = dateObj.year;
        const month = dateObj.month.number;

        this.setState({ currentYear: year, currentMonth: month }, () => {
            this.refreshData();
        });
    };
    showLine(line, formattedDate) {
        this.httpPost("api/v1/productionline/calendar/detail", {
            date: formattedDate,
            lineId: line.lineId
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                this.state.loading = false;

                if (data.status === 1) {

                    var component = <div className="modal fade listModal in show" tabIndex="-1" role="dialog">
                        <div className="modal-backdrop fade in" style={{ "height": "100%" }} onClick={e => this.setState({ popupComponent: null })}></div>
                        <div className="modal-dialog ui-draggable">
                            <div className="modal-content">
                                <div className="modal-body" style={{ "padding": "0" }}>
                                    <div className="modal-header modal-header-info">
                                        <button type="button" className="close hand" onClick={e => this.setState({ popupComponent: null })} aria-label="Close"><span aria-hidden="true">×</span></button>
                                        <h4 className="modal-title">
                                            جزئیات تقویم تولید
                                        </h4>
                                    </div>
                                    <div className="modal-body">
                                        <div className="container-fluid">
                                            <div className="row">
                                                <div className="col-sm-3">
                                                    <div className="form-group">
                                                        <label for="bank-name" className="title1">نام خط تولید: {data.lineName}</label>
                                                    </div>
                                                </div>
                                                <div className="col-sm-3">
                                                    <div className="form-group">
                                                        <label for="bank-name" className="title1">میزان کل سفارشات: {data.capacity}</label>
                                                    </div>
                                                </div>
                                                <div className="col-sm-3">
                                                    <div className="form-group">
                                                        <label for="bank-name" className="title1">تعداد کل سفارشات: {data.count}</label>
                                                    </div>
                                                </div>
                                                <div className="col-sm-3">
                                                    <div className="form-group">
                                                        <label for="bank-name" className="title1">تاریخ: <span style={{ display: "inline-block" }}>{data.date}</span></label>
                                                    </div>
                                                </div>
                                                <div className="col-sm-12">
                                                    <div className="nk-tb-list nk-tb-ulist">
                                                        <div className="nk-tb-item nk-tb-head">
                                                            <div className="nk-tb-col text-center"><span className="sub-text">شماره سفارش</span></div>
                                                            <div className="nk-tb-col text-center"><span className="sub-text">نام مشتری</span></div>
                                                            <div className="nk-tb-col text-center"><span className="sub-text">شماره موبایل مشتری</span></div>
                                                            <div className="nk-tb-col text-center"><span className="sub-text">تعداد</span></div>
                                                            <div className="nk-tb-col text-center"><span className="sub-text">واحد</span></div>
                                                        </div>
                                                        {data.records.map((record, index) =>
                                                            record.items.map((item, index) =>
                                                                <div className="nk-tb-item">
                                                                    <div className="nk-tb-col">
                                                                        <span className="sub-text text-center">{record.fullNumber}</span>
                                                                    </div>
                                                                    <div className="nk-tb-col">
                                                                        <span className="sub-text text-center">{record.personName}</span>
                                                                    </div>
                                                                    <div className="nk-tb-col">
                                                                        <span className="sub-text text-center">{record.personMobile}</span>
                                                                    </div>
                                                                    <div className="nk-tb-col">
                                                                        <span className="sub-text text-center">{item.count}</span>
                                                                    </div>
                                                                    <div className="nk-tb-col">
                                                                        <span className="sub-text text-center">{item.unitName}</span>
                                                                    </div>
                                                                </div>
                                                            ))}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-dim btn-outline-light" onClick={e => this.setState({ popupComponent: null })}>انصراف </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    this.showComponents({ component: component });

                }
                else {
                    this.showErorrMessage(data.message);
                }
            });
    }
    renderForm() {
        if (!this.hasPermission(this.state.menuId)) return this.renderPermissionDenied();
        if (this.state.moduleAccessStatus <= 0) return this.renderSystemModuleModuleAccessMessage(this.state.moduleAccessStatus);

        const { calendarType } = this.state;

        return <div className="nk-content-body">
            <div className="nk-block">

                <div className="row">
                    <div className="col-md-12">
                    {/*<button onClick={this.toggleCalendarType}>*/}
                    {/*    تغییر به {calendarType === "persian" ? "میلادی" : "شمسی"}*/}
                    {/*</button>*/}
                        <Calendar
                            style={{ width: "100%" }}
                            calendar={calendarType === "persian" ? persian : gregorian}
                            locale={calendarType === "persian" ? customPersian : gregorian_en}
                            onMonthChange={this.handleMonthChange}
                        mapDays={({ date }) => {
                            const formattedDate = date.format("YYYY-MM-DD");
                            const lines = this.getLinesForDate(formattedDate);

                            return {
                                children: [
                                        <span>{formattedDate.split("-")[2]}</span>,
                                        <div style={{width: "100%",height: "100%",position: "relative"}}>
                                        {lines.map((line,lineIndex) => (
                                            <span key={line.lineId} onClick={e => this.showLine(line, formattedDate)} title={"میزان سفارش: " + line.capacity} 
                                                style={{
                                                        right: (lineIndex * 25) + 'px',
                                                        width: 20,
                                                        height: 20,
                                                        borderRadius: "50%",
                                                        backgroundColor: line.color,
                                                        margin: 2
                                                }}></span>
                                        ))}
                                        </div>
                                    ]
                            };
                        }}
                        />
                    </div>
                    <div className="col-md-12 mt-2">
                        <div className="card  p-4">
                            <p>راهنمای رنگهای خطوط تولید</p>
                            {this.state.data.lines.map(line => (
                                <div style={{"display": "flex", "gap": "10px"}}>
                                    <span
                                        style={{
                                            width: 20,
                                            height: 20,
                                            borderRadius: "50%",
                                            backgroundColor: line.color,
                                            margin: 2,
                                            display: "inline-block"
                                        }}
                                    >
                                    </span>
                                    {line.name}
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                <Header data={this.state.data} />,
                <div className="nk-content ">
                    <div className="container-fluid">
                        <div className="nk-content-inner">
                            {this.isEmpty(this.state.data.global.companies) ? this.renderNoCompanyRegister() : this.renderForm()}
                        </div>
                    </div>
                </div>,
                <Footer />,
                this.renderPopupComponent(),
            ];

        return contents;
    }
}